/**
 * Client-side fetcher for smart-tag suggestions
 */

import { SmartTagRequest, TagResponse, TagResponseSchema } from 'data/smart-tags/types';

/**
 * Fetch matching smart tags for a query.
 *
 * @param request The query text plus optional matching tuners.
 * @param signal  Optional AbortSignal so callers (e.g. a debounced typeahead)
 *                can cancel a stale in-flight request.
 * @returns The validated {@link TagResponse} (tags sorted best-match first).
 */
export async function fetchSmartTags(request: SmartTagRequest, signal?: AbortSignal): Promise<TagResponse> {
  const res = await fetch('/api/tags', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
    signal,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`fetchSmartTags: ${res.status} ${text}`);
  }

  const json: unknown = await res.json();
  return TagResponseSchema.parse(json);
}
